export const CONFIG = {
  credentials: {
    staging: {
      account: 'future-facilitator@jimbutton-foundation.org',
      clientId: 'AXBI2iwU38-SqcOgrYSDBtxKYQdM_xe90iNxA64y5SOxU-MP79UZJv4ecfAaxcS8lasiSjAO0cyA-RCQ'
    },
    production: {
      account: 'future@jimbutton-foundation.org',
      clientId: 'AQZ7vgmRE2Zm7Cc3axxURwjuIC9pVwi1bDHTuKyFrzZ3LAy1p2I661SU3VU1iG6b7ekXiUPN34o0q2U6'
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/config/paypal.config.ts